import { render, staticRenderFns } from "./subclassifiersMainView.vue?vue&type=template&id=581fff97&scoped=true&"
import script from "./subclassifiersMainView.vue?vue&type=script&lang=js&"
export * from "./subclassifiersMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581fff97",
  null
  
)

export default component.exports